import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: calc(85vh - 50px); // Subtraindo o padding do modal
`;

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-right: 8px; // Espaço para a scrollbar
  margin-right: -8px; // Compensar o padding para alinhamento
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const FixedFooter = styled.div`
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const AvatarContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const ProfileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const TextCotainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Title = styled.span`
  font-weight: 700;
  font-size: 20px;
`;

export const Text = styled.span`
  
`;

export const Subtitle = styled.span`
  font-size: 10px;

  white-space: nowrap;      
  overflow: hidden;         
  text-overflow: ellipsis;  
`;

export const PremiacaoInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
`;

export const PremiacaoImagem = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 10px;
  object-fit: cover;
  `;

export const ValorContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const ExtratoContainer = styled.div`
  margin-bottom: 20px;
`;

export const ExtratoTitle = styled.span`
  font-weight: bold;
  margin-bottom: 10px;
  display: block;
`;

export const ExtratoList = styled.div`
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px;
  background-color: #fafafa;
`;

export const ExtratoItem = styled.div<{ isLast?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: ${props => props.isLast ? 'none' : '1px solid #f0f0f0'};
  
  &:hover {
    background-color: #f5f5f5;
    border-radius: 4px;
    margin: 0 -4px;
    padding: 8px 4px;
  }
`;

export const ExtratoItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ExtratoItemValue = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const ExtratoPoints = styled.span<{ isPositive: boolean }>`
  color: ${props => props.isPositive ? '#4CAF50' : '#f44336'};
  font-weight: 600;
`;

export const ExtratoDate = styled.span`
  font-size: 12px;
  color: #666;
`;

export const UserInfoHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const ExtratoToggleButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: transparent;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #f5f5f5;
    border-color: #d0d0d0;
  }
  
  svg {
    transition: transform 0.2s ease;
  }
  
  &[data-expanded="true"] svg {
    transform: rotate(90deg);
  }
`;

// Value summary rows with subtle color coding (no layout changes)
export const ValueInfo = styled(PremiacaoInfo)`
  &[data-type="original"] span:last-child {
    color: #455A64; /* blue-grey for base value */
    font-weight: 500;
  }
  &[data-type="tax"] span:last-child {
    color: #E65100; /* deep orange for tax */
    font-weight: 600;
  }
  &[data-type="total"] span:last-child {
    color: #2E7D32; /* green for total */
    font-weight: 700;
  }
  &[data-type="total"] {
    border-top: 1px solid #e0e0e0;
    padding-top: 6px;
    margin-top: 2px;
  }
`;